// Premium design tokens shared across the CV explainer chrome.

export const FONT_DISPLAY = "'Clash Display', 'General Sans', system-ui, sans-serif"
export const FONT_BODY = "'General Sans', system-ui, sans-serif"
export const FONT_MONO = "'JetBrains Mono', ui-monospace, 'SF Mono', monospace"

// Award-site easing — slow-out, gentle settle.
export const EASE = [0.16, 1, 0.3, 1]

// One accent hue per chapter — drives the atmosphere glow, progress bar,
// HUD and frame so the whole experience shifts colour as you scroll.
export const CHAPTER_ACCENTS = [
  '#818cf8', // 0  Hero
  '#a855f7', // 1  Human vs CV
  '#6366f1', // 2  Pixels
  '#ec4899', // 3  Tensor
  '#a855f7', // 4  Convolution
  '#f43f5e', // 5  CNN
  '#fbbf24', // 6  How Models Learn
  '#6366f1', // 7  Detection
  '#ec4899', // 8  Segmentation
  '#818cf8', // 9  ViT
  '#22c55e', // 10 Foundation
  '#a855f7', // 11 Multimodal
  '#fb7185', // 12 Generative
  '#38bdf8', // 13 Universe
  '#fbbf24', // 14 Roadmap
]

export const accentFor = i => CHAPTER_ACCENTS[i] ?? CHAPTER_ACCENTS[0]
